import { render, staticRenderFns } from "./CreateCode.vue?vue&type=template&id=36455932&scoped=true&"
import script from "./CreateCode.vue?vue&type=script&lang=js&"
export * from "./CreateCode.vue?vue&type=script&lang=js&"
import style0 from "./CreateCode.vue?vue&type=style&index=0&id=36455932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36455932",
  null
  
)

export default component.exports